import type { RouterConfig } from '@nuxt/schema'

// https://nuxt.com/docs/guide/recipes/custom-routing#using-approuteroptions
export default <RouterConfig>{
  stringifyQuery: (query) => {
    /**
     * !!! VERCEL DEPLOY FIX - https://github.com/nuxt/nuxt/issues/14316
     * Fixing query params with special chars like SPACE - by default nuxt uses encoding 'q=text+p', vercel uses 'q=text%20p'
     * so vercel proxy redirects 'q=text+p' to 'q=text%20p' and NUXT then redirects back to 'q=text%20p',
     * so infinite redirects are happening
     */
    const keys = Object.keys(query).filter(key => query[key] && query[key] !== 'undefined')
    return keys.map(key => `${key}=${encodeURIComponent(query[key] as string)}`).join('&')
  }
}